






















import { Vue, Component, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { InvoiceListEntry } from "../../models/invoice-list-entry";
import AnalyticsStore from "../../store/analytics.store";
import { columbiaDocumentsService } from "../../services/columbia-documents.service";

@Component
export default class AnalyticsInvoiceItem extends Vue {
  private analyticsStore: AnalyticsStore = getModule(
    AnalyticsStore,
    this.$store
  );

  @Prop() invoice!: InvoiceListEntry;

  private get selectedSite() {
    return this.analyticsStore.getSelectedSite;
  }
  private get selectedInvoice() {
    return this.analyticsStore.getSelectedInvoice;
  }

  isInvoiceSelected(id: string) {
    if (this.selectedInvoice != null) {
      return this.selectedInvoice.invid === id;
    } else {
      return false;
    }
  }

  async changeSelectedInvoice(invoice: InvoiceListEntry) {
    this.analyticsStore.updateSelectedInvoice(invoice);
    if (invoice.columbiaid !== null && invoice.columbiaid !== "") {
      const pdfLocation: ArrayBuffer = await columbiaDocumentsService.loadDataAsync(
        invoice.columbiaid,
        this.selectedSite
      );
      this.analyticsStore.updateSelectedInvoicePdfLocation(pdfLocation);
    } else {
      this.analyticsStore.updateSelectedInvoicePdfLocation("");
    }
  }
}
